import {useState} from "react"
import {BaseButton, BaseInput, BasePopup, BaseTextArea} from "components"
import {FormLabel} from "components/Form"
import {academicCourseGradesService} from "services"
import {useMutation} from "hooks/useMutation"
import {handleError, toastError, toastSuccess} from "helpers"
import styles from "./EditGradePopup.module.css"

type Props = {
    isShow: boolean
    activity: {id: number; grade: number; description: string}
    onClose: () => void
    onSuccess: () => void
}

export const EditGradePopup = (props: Props) => {
    const {isShow, activity, onClose, onSuccess} = props
    const [data, setData] = useState({grade: activity.grade, description: activity.description})

    const editActivityMutation = useMutation((data: any) => academicCourseGradesService.editClassActivities(data), {
        onError: (error) => handleError(error),
        onSuccess: () => {
            toastSuccess("Edit Activity successful")
            onSuccess()
        }
    })

    const onSubmit = () => {
        if (data.grade < 0 || data.grade > 100) {
            toastError("Grade must be between 0 and 100")
            return
        }
        editActivityMutation.mutate({
            academicActivityId: activity.id,
            grade: +data.grade,
            description: data.description
        })
    }

    return (
        <BasePopup isShow={isShow} onClose={onClose} width="70vw" leftIcon="WARNING_SOLID" leftIconColor="#fff">
            <div>
                <p className={styles.editGradeTitle}>Editing grade with ID: {activity.id}</p>
                <div className={styles.editGradeBody}>
                    <div>
                        <FormLabel label="Grade" />
                        <BaseInput
                            value={data.grade}
                            type="number"
                            min={0}
                            max={100}
                            onChange={(value) =>
                                setData((prev) => ({
                                    ...prev,
                                    grade: value,
                                    description: `Graded: ${value}; Max points: 100`
                                }))
                            }
                        />
                    </div>
                    <div>
                        <FormLabel label="Description" />
                        <BaseTextArea
                            value={data.description}
                            onChange={(value) => setData((prev) => ({...prev, description: value}))}
                        />
                    </div>
                </div>
                <div className={styles.editGradeActions}>
                    <BaseButton title="Cancel" variant="secondary" onClick={onClose} />
                    <BaseButton title="Save" onClick={onSubmit} loading={editActivityMutation.isLoading} />
                </div>
            </div>
        </BasePopup>
    )
}
